import React, { useEffect, useState } from "react";
import SingleCardSchedule from "../Reuse/SingleCardSchedule";
import EventImg from "../../../../../assets/images/SakibBanner2.png";
import { useLocation } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";
import LoaderPost from "../../../../Reuseable/LoaderPost";
import Nodata from "../../../../Reuseable/Nodata";

const AuditionSingleSchedule = () => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
  const location = useLocation();
  const eventType = location.state;
  const [postData, setPostData] = useState([]);
  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios
      .get(`/api/audition-admin/dashboard/posts/${eventType?.title}`)
      .then((res) => {
        setBuffer(false);
        if (res.data.status === 200) {
          setPostData(res.data.post);
        }
      });
  }, []);

  return (
    <>

{buffer ? (
        <LoaderPost />
      ) : (
     
     
     <>
       {postData.length !== 0 ? (
     <div className="col-md-12 ">
        <div className="row">
          
          {postData?.map((post) => (
            <SingleCardSchedule
              post={post}
              eventType={eventType}
              key={post.id}
              link={`/audition-admin/schedule/single/${post.id}/${eventType?.title}`}
              image={
                post?.banner
                  ? post?.banner == null
                    ? EventImg
                    : imageCdnUrl+post?.banner
                  : post.video == null
                  ? EventImg
                  : videoCdnUrl+post?.video
              }
              time={moment(post?.created_at).format("HH:mm a")}
              date={moment(post?.created_at).format("LL")}
              title={post?.title}
              description={post?.description}
            />
          ))}
        </div>
      </div>
      ) : (
        <Nodata />
      )}
     </>

)}
    </>
  );
};

export default AuditionSingleSchedule;
